import { BUTTON_SIZE, BUTTON_TYPE, COLORS, DSButton } from '@repo/design-system/index'
import { QIcon_mic_default } from '@repo/icons/index'
import { useEffect, useState } from 'react'
import { n_ai_speaking, n_common } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import LoadingSpinner from '../../../common/LoadingSpinner'

const RecordWrapper = ({ recordingStatus, setRecordingStatus, onCancel }) => {
  const { t, locale } = useTranslation()

  // ('idle' | 'starting' | 'recording' | 'stopping' | 'cancelling' | 'preparing' | 'waiting')
  const [completeText, cancelText] = [n_ai_speaking.ai_session.btn5, n_common.btn_cancel].map((i) => t(i))
  const [waitingTranscription, setWaitingTranscription] = useState(false)
  const [audioLevel, setAudioLevel] = useState(0)

  const [micTextIndex, setMicTextIndex] = useState(0)
  const micTextArray = [
    t(n_ai_speaking.ai_session.msg1),
    t(n_ai_speaking.ai_session.msg2),
    t(n_ai_speaking.ai_session.msg3),
  ]
  const [fixMicTextForTenSeconds, setFixMicTextForTenSeconds] = useState(true)

  useEffect(() => {
    let interval

    if (fixMicTextForTenSeconds) {
      setTimeout(() => {
        setFixMicTextForTenSeconds(false)
      }, 10000)
    } else {
      interval = setInterval(() => {
        const nextIndex = (micTextIndex + 1) % micTextArray.length
        setMicTextIndex(nextIndex)
      }, 3000)
    }

    return () => clearInterval(interval)
  }, [micTextIndex, fixMicTextForTenSeconds])

  useEffect(() => {
    //▶️ 다른 모든 리스너는 없애고, 오디오에 직접적으로 사용되는 리스너는 여기에 존재합니다.
    function handleMessage(event) {
      let data
      try {
        data = JSON.parse(event.data)
      } catch (e) {
        console.error('Invalid message format:', e)
        return
      }

      if (data.type === 'audioLevel') {
        setAudioLevel(data.level)
      }
    }

    window.addEventListener('message', handleMessage)
    document.addEventListener('message', handleMessage) // iOS 대응

    // 클린업
    return () => {
      window.removeEventListener('message', handleMessage)
      document.removeEventListener('message', handleMessage)
    }
  }, [])

  return (
    <div
      className={'bg-white opacity-95 flex flex-col bottom-[8px] items-center justify-center pt-[12px]'}
      style={{
        width: '100%',
        paddingBottom: `calc(12px + env(safe-area-inset-bottom))`,
        paddingLeft: 12,
        paddingRight: 12,
      }}
    >
      {recordingStatus === 'idle' && (
        <div className="bg-white text-center flex items-center justify-center h-[32px]">
          <div className="items-center justify-center Body2-14Md text-gray-500 flex">{micTextArray[micTextIndex]}</div>
        </div>
      )}
      {(recordingStatus === 'idle' || recordingStatus === 'cancelling') && (
        <>
          <div
            className="mt-[12px] flex flex-col items-center justify-center bg-purple-500 
            rounded-[100px] w-[64px] h-[64px] cursor-pointer hover:bg-purple-600 active:bg-purple-700"
            onClick={(_e) => {
              if (recordingStatus === 'cancelling') {
                return
              }

              setRecordingStatus('starting')

              setTimeout(() => {
                window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'startRecording' }))
              }, 100)
            }}
          >
            <QIcon_mic_default width={32} height={32} className="bg-contain" color={COLORS.WHITE} />
          </div>
        </>
      )}
      {(recordingStatus === 'starting' ||
        recordingStatus === 'stopping' ||
        recordingStatus === 'preparing' ||
        recordingStatus === 'waiting') && (
        <div className="w-[64px] h-[64px]">
          <LoadingSpinner lg show primary />
        </div>
      )}
      {recordingStatus === 'recording' && (
        <>
          <span className="text-gray-400" style={{ fontSize: 14 }}>
            Listening
          </span>

          <div className="mt-[16px] flex itmes-center justify-center w-full relative flex-1">
            <DSButton
              onClick={(_e) => {
                onCancel()
              }}
              type={BUTTON_TYPE.OUTLINE}
              size={BUTTON_SIZE.LG}
              className="flex-[0.3]"
            >
              <div className="Body1-14BD">{cancelText}</div>
            </DSButton>
            <div className="w-[8px]" />
            <DSButton
              type={BUTTON_TYPE.SOLID}
              size={BUTTON_SIZE.LG}
              onClick={(_e) => {
                setRecordingStatus('stopping')
                window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'stopRecording' }))
              }}
              isLoading={waitingTranscription}
              className="flex-[0.7]"
            >
              <div className="Body1-14BD text-white">{completeText}</div>
            </DSButton>
          </div>
        </>
      )}
      {/* {renderRecordingButton()}
        {errorModal && <ConversationErrorPopup showErrorModal={showErrorModal} setShowErrorModal={setShowErrorModal} />}
        <NoRecognizedModal show={showNoRecognizedModal} setShow={setShowNoRecognizedModal} /> */}
    </div>
  )
}

export default RecordWrapper
